<template>
  <div class="game-score" :class="{ 'game-score--app' : $inApp }">
    <img class="game-score__bg" src="/img/misc/score-bg.png" alt="banner score background">

    <p class="game-score__points" v-html="`${$store.state.score}`" />
  </div>
</template>

<script>
export default {
  name: 'GameScore',
};
</script>

<style lang="scss" scoped>
.game-score {
  position: fixed;
  top: 20px;
  right: 0;

  color: $color-white;
  font-weight: 800;
  @extend %font-score;

  @include mq(ipadP) {
    top: 40px;
  }

  &.game-score--app {
    top: 100px;
  }

  &__bg {
    min-width: 70px;
    max-width: 240px;
    width: 6vw;
    margin: 0;
  }

  &__points {
    position: absolute;
    top: 50%;
    left: 45%;

    transform: translateY(-50%);
  }
}
</style>
